import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { configureApi } from './services/api'
import { clearSession, getAccessToken } from './services/session'
import 'react-toastify/dist/ReactToastify.css'
import './assets/css/global.css'

configureApi({
  getToken: getAccessToken,
  onUnauthorized: () => {
    clearSession()
    if (window.location.pathname !== '/login') window.location.assign('/login')
  },
})

const container = document.getElementById('root')
if (!container) throw new Error('Elemento #root não encontrado no index.html.')

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
